export default {
    getCountryCodeFromPosition: function(position) {
        const geocoder = new google.maps.Geocoder();
        const latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);

        return new Promise((resolve, reject) => {
            geocoder.geocode(
                {
                    location: latlng
                },
                (results, status) => {
                    var gps_last_result = results.slice(-1)[0];

                    if (status === google.maps.GeocoderStatus.OK) {
                        var gps_country_code = gps_last_result.address_components.slice(-1)[0].short_name;

                        resolve(gps_country_code);
                    } else {
                        reject(new Error(status));
                    }
                }
            );
        });
    },
}
